module.exports = __webpack_public_path__ + "fonts/upgrade_icon.svg";